/* const UserRoles = [
    {
        id: 1,
        name: 'Admin',
        label: 'Admin'
    },
    {
        id: 2,
        name: 'ESS',
        label: 'ESS'
    },
    {
        id: 3,
        name: 'Supervisor',
        label: 'Supervisor'
    }
]; */

const UserRoles = {
  ADMIN: {
    id: 1,
    name: 'Admin',
    label: 'Admin',
  },
  ESS: {
    id: 2,
    name: 'ESS',
    label: 'ESS',
  },
  SUPERVISOR: {
    id: 3,
    name: 'Supervisor',
    label: 'Supervisor',
  },
};

export default UserRoles;
